export class FileGroup {
  account_group_id: string;
  title: string;
  description: string;
  date: string;
  files: any[];
  file_group_id: string;
  app_id: string;
  uploadedBy: string;
  created: string;

  constructor(data: any) {
    Object.keys(data).map((key) => {
      this[key] = data[key];
    });
  }
}
